import React from 'react';
import { templateLibrary } from '../data/resources';
import { templateSamples } from '../data/pendingContent';
import { siteConfig } from '../data/siteConfig';
export function TemplateLibrary() {
  return <section aria-labelledby="library-title" className="on-dark bg-plum text-cream px-5 sm:px-8 py-16 sm:py-24" data-id="element-192" data-mp="1cim31k9zokor">
      <div className="max-w-6xl mx-auto" data-id="element-193" data-mp="1hgxe1yc0t18k">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center" data-id="element-194" data-mp="1hfmanzmhlvhz">
          <div className="lg:col-span-6" data-id="element-195" data-mp="jw1d8o95wgnb">
            <div className="rounded-[2rem] overflow-hidden aspect-square ring-1 ring-butter/50" data-id="element-196" data-mp="ot1i4vu9zdcu">
              <img src={templateLibrary.image} alt={templateLibrary.imageAlt} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-197" data-mp="tsnxbatnz3oa" />
            </div>
          </div>

          <div className="lg:col-span-6" data-id="element-198" data-mp="ykxfg4ojezg0">
            <p className="font-serif text-lg font-semibold text-berry-light" data-id="element-199" data-mp="12npp47s3chq">La raccolta di cartamodelli</p>
            <h2 id="library-title" className="mt-4 font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold" data-id="element-200" data-mp="61ii8xvjsff1">
              {templateLibrary.name}
            </h2>
            <div className="mt-5 h-px w-16 bg-butter" aria-hidden="true" data-id="element-201" data-mp="2l6u4zn8qzrik" />
            <p className="mt-5 text-base sm:text-lg leading-relaxed text-cream/85 max-w-lg" data-id="element-202" data-mp="2ggnhxrtvwf2f">
              {templateLibrary.description}
            </p>

            <dl className="mt-9 grid sm:grid-cols-2 gap-px rounded-2xl overflow-hidden bg-cream/15" data-id="element-203" data-mp="2bgss7rluhviy">
              <div className="bg-plum p-5" data-id="element-204" data-mp="27gqqjig4123o">
                <dt className="font-serif text-lg font-semibold" data-id="element-205" data-mp="22gvy3agos4gi">Le guide</dt>
                <dd className="mt-1 text-sm leading-relaxed text-cream/80" data-id="element-206" data-mp="22iywahrzt3wb">
                  Ti accompagnano nella tecnica, nei materiali e nelle rifiniture.
                </dd>
              </div>
              <div className="bg-plum p-5" data-id="element-207" data-mp="1sksx47xkmbv5">
                <dt className="font-serif text-lg font-semibold" data-id="element-208" data-mp="3rwc1sabucxz0">I cartamodelli</dt>
                <dd className="mt-1 text-sm leading-relaxed text-cream/80" data-id="element-209" data-mp="3mwz8p7udmunz">
                  Ti offrono riferimenti di forma da seguire durante la lavorazione.
                </dd>
              </div>
            </dl>

            <p className="mt-6 text-sm text-cream/80" data-id="element-210" data-mp="1pyjs8l69n7v3">
              Inclusa nel pack Tricotin con Amore.
            </p>

            <a href="#acquista" className="mt-9 inline-flex w-full sm:w-auto justify-center whitespace-nowrap rounded-full bg-cream px-8 py-4 text-base font-semibold text-plum hover:bg-blush transition-colors duration-200" data-id="element-211" data-mp="1baowevwyonds">
              Scopri tutto il pack — {siteConfig.price}
            </a>
          </div>
        </div>

        {templateSamples.length > 0 && <ul className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-212" data-mp="1uxmxo6q5rg3l">
            {templateSamples.map(t => <li key={t.src} className="aspect-[3/4] rounded-xl overflow-hidden bg-cream" data-id="element-213" data-mp="1yyf64xr7hgyt">
                <img src={t.src} alt={t.alt} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-214" data-mp="jhol3svrubxm" />
              </li>)}
          </ul>}
      </div>
    </section>;
}